import { useNavigate } from 'react-router-dom';
import { Box, Avatar, Typography, Chip, useTheme } from '@mui/material';

const TYPE_COLOR   = { CREW: 'primary', 'NON-CREW': 'default' };
const STATUS_COLOR = { true: 'success', false: 'error' };

const EmployeeCardList = ({ employees = [] }) => {
    const navigate = useNavigate();
    const theme    = useTheme();

    if (employees.length === 0) {
        return (
            <Box display="flex" justifyContent="center" p={4}>
                <Typography variant="body2" color="text.secondary">No employees found.</Typography>
            </Box>
        );
    }

    return (
        <Box>
            {employees.map((emp, idx) => (
                <Box
                    key={emp._id}
                    onClick={() => navigate(`/employees/${emp._id}`)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 1,
                        gap: 2,
                        cursor: 'pointer',
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        '&:hover': { bgcolor: 'action.hover' },
                    }}
                >
                    <Typography 
                        variant="subtitle1" 
                        color="text.disabled" 
                        sx={{ minWidth: 20, textAlign: 'right', flexShrink: 0 }}
                    >
                        {idx + 1}
                    </Typography>
                    <Avatar
                        sx={{ 
                            width: 36, 
                            height: 36, 
                            fontSize: 14, 
                            bgcolor: 'primary.main', 
                            flexShrink: 0 
                        }}
                    >
                        {emp.employeeName?.charAt(0)?.toUpperCase() || '?'}
                    </Avatar>
                    <Box flex={1} minWidth={0}>
                        <Typography variant="body2" fontWeight={600} noWrap>
                            {emp.employeeName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" noWrap>
                            {[emp.employeeCode, emp.rank, emp.homeBase].filter(Boolean).join(' · ')}
                        </Typography>
                    </Box>
                    <Box 
                        display="flex" 
                        flexDirection="column" 
                        alignItems="flex-end" 
                        gap={1}
                    >
                        <Chip
                            label={emp.isActive ? 'Active' : 'Inactive'}
                            color={STATUS_COLOR[emp.isActive]}
                            size="small"
                            sx={{ fontSize: '0.65rem', height: 18 }}
                        />
                        <Chip
                            label={emp.employeeType || 'NON-CREW'}
                            color={TYPE_COLOR[emp.employeeType] || 'default'}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: '0.65rem', height: 18 }}
                        />
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default EmployeeCardList;
